import { useState, useEffect } from 'react'
import Header from '../Components/Header';
import { BoxHover } from '../Components/BoxHover';
import Productspicture from '../Components/Productspicture';
import Footer from "../Components/Footer"
import { quantumHardwareProducts } from '../Data/Products';
import BackgroundGradient from '../Images/BackgroundGradient.png'
import BackgroundGradientSmall from '../Images/BackgroundGradientSmall.png'





export default function Hardware() {
 
  
  const [backgroundImage, setBackgroundImage] = useState(``);

  useEffect(() => {
    const updateBackgroundImage = () => {
      if (window.innerWidth < 640) {
        setBackgroundImage(`url(${BackgroundGradientSmall})`);
      } else {
        setBackgroundImage(`url(${BackgroundGradient})`);
      }
    };

    // Set initial background image
    updateBackgroundImage();

    // Update background image on window resize
    window.addEventListener('resize', updateBackgroundImage);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', updateBackgroundImage);
  }, []);

 
 
 
  return (
    <div className="w-full  flex flex-col gap-0 items-center justify-center bg-primary7">
      <div
        className="w-full width flex flex-col gap-0 items-center justify-center bg-contain bg-repeat"
        style={{ backgroundImage: backgroundImage }}
      >
        <Header id={3} />

        <div className="w-full bg-primary7 flex flex-col items-center justify-center gap-6 ">
          <div className="w-full  pt-20 pb-10">
            <Productspicture
              title="Quantum Hardware"
              productsList={quantumHardwareProducts}
            />

            <div className="max-w-5xl   mx-auto px-8">
              <BoxHover items={quantumHardwareProducts} />
            </div>
          </div>
          {/* <div className="w-full width md:px-10 pt-5 flex flex-col items-center justify-center gap-2">
            <TitleContent
              title="We build for future"
              content="All our algorithms are designed with a vision of future in quantum space and are scalable, able to solve problems that are too big or too difficult for current technologies."
            />
            <div className="max-w-5xl  mx-auto px-8">
              <BoxHover items={products} />
            </div>
          </div> */}
          {/* <div className='w-full width flex flex-col items-center justify-center gap-2'>
          
          <Form/>
        </div> */}

          <Footer showpage={false} />
        </div>
      </div>
    </div>
  );
}
